import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { EventComponent } from "../../components/event"

export const EventPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <EventComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}